import { AxiosResponse } from 'axios'
import { apiNode } from './api'
import {
	DefaultInboxParamsProps,
	DeleteInboxParamsProps,
	GetInboxDataResponse,
	GetInboxParamsProps,
	GetUnreadInboxCountDataResponse,
	MultiActionInboxDataProps,
	MultiDeleteInboxDataProps,
	UpdateStatusInboxDataProps,
} from './types/inbox.interfaces'

const URL = '2/inbox/notifications'

export const InboxService = {
	async get({
		...params
	}: GetInboxParamsProps): Promise<GetInboxDataResponse> {
		const response: AxiosResponse<GetInboxDataResponse> =
			await apiNode.get<GetInboxDataResponse>(`${URL}`, {
				params,
			})
		return response.data
	},
	async getUnreadNumber(): Promise<GetUnreadInboxCountDataResponse> {
		const response: AxiosResponse<GetUnreadInboxCountDataResponse> =
			await apiNode.get<GetUnreadInboxCountDataResponse>(`${URL}/unread`)
		return response.data
	},

	// single actions
	async toggleRead({ id, value }: UpdateStatusInboxDataProps) {
		return await apiNode.patch(`${URL}/${id}/read`, { value })
	},
	async togglePinned({ id, value }: UpdateStatusInboxDataProps) {
		return await apiNode.patch(`${URL}/${id}/pin`, { value })
	},
	async delete({ id }: { id: string }) {
		return await apiNode.delete(`${URL}/${id}/delete`)
	},

	// ---

	// multi actions
	async multiToggleRead({ data }: MultiActionInboxDataProps) {
		return await apiNode.patch(`${URL}/read`, data)
	},
	async multiToggleFavorite({ data }: MultiActionInboxDataProps) {
		return await apiNode.patch(`${URL}/pin`, data)
	},
	async deleteMultiple({ ids }: DeleteInboxParamsProps) {
		return await apiNode.delete(`${URL}/delete`, {
			data: { ids },
		})
	},
}
